import { useQueries } from '@tanstack/react-query';
import { useStateKey } from '../../../../iwQueryClient/useStateKey';
import { normaliseRepaymentSchedule } from '../../MyOffers.helpers';
import { FormalOffers } from '../../MyOffers.types';
import { GetDrawDownRepaymentScheduleCreditFacilityResponse } from '@iwoca/lapi-client/edge';

export function useGetDrawdownSchedules(
    formalOffers: FormalOffers,
    drawdownAmount: number
) {
    const stateKey = useStateKey();

    return useQueries({
        queries: formalOffers.map((formal_offer) => {
            return {
                queryKey: [
                    'draw_down_repayment_schedule',
                    stateKey,
                    drawdownAmount,
                    formal_offer.offer_id,
                    formal_offer.product_type
                ],
                queryFn: async () => {
                    // eslint-disable-next-line pandora/prefer-lapi-client
                    const response = await fetch(
                        `/api/lending/edge/draw_down_repayment_schedule/${stateKey}/${formal_offer.product_type}/${formal_offer.offer_id}/?amount=${drawdownAmount}`
                    );

                    return response.json();
                },
                select: (
                    data: GetDrawDownRepaymentScheduleCreditFacilityResponse
                ) =>
                    normaliseRepaymentSchedule({
                        formalOffer: formal_offer,
                        repaymentSchedule: data.data
                    })
            };
        })
    });
}
